module.exports = __webpack_public_path__ + "static/media/bgNuevamente.5c2eaf8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgNuevamente.png
// module id = 1264
// module chunks = 0